export const SHOW_ALERT = 'SHOW_ALERT';

export const showAlert = (data) => ({
    type: SHOW_ALERT,
    payload: data
});